import {
  Component,
  HostListener,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Input,
} from '@angular/core';
import { RootScopeService } from '../../../services/root-scope.service';
import { CustBusService } from '../../../services/customer-search-bussiness-logic.service';
import { GenesysCloudService } from '../../../services/genesys-cloud.service';
import * as Constants from '../../../models/Constants';
import { FormControl, FormGroup } from '@angular/forms';
import { CallCustomerAttributes } from '../../../models/customer.model';
import { Subscription } from 'rxjs';
import { EncryptDecryptService } from '../../../services/encrypt-decrypt.service';
import { CustomerAccountBusinessLogicService } from '../../../services/customer-account-business-logic.service';
import _ from 'lodash';
import { MatSelect } from '@angular/material/select';
import { Global } from 'src/app/global/globalApi';
import { ApiService } from 'src/app/services/api.service';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import { ALIS_OUTBOUND_CONVERSATION } from 'src/app/models/ALIS_Conversations';

interface Clientvalue {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-abt-the-interaction-card',
  templateUrl: './abt-the-interaction-card.component.html',
  styleUrls: ['./abt-the-interaction-card.component.scss'],
})
export class AbtTheInteractionCardComponent implements OnInit {
  @Output()
  goToAuthenticatePageEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  changeCustomerTypeEmitter: EventEmitter<any> = new EventEmitter();

  showContent: boolean = true;
  loaderType = Constants.LOADER_TYPE.CARD;
  securityLevel4 = Constants.securityLevels.SL4;
  channel = Constants.conversion;
  iconConfig: any;
  customerType = new FormControl();
  roleType = new FormControl();
  myTimeoutId: ReturnType<typeof setTimeout> | any;
  form = new FormGroup({
    customerType: this.customerType,
    roleType: this.roleType,
  });
  outboundCallTriggerSub: Subscription = new Subscription();
  authenticateClass: string = '';
  defaultCustomerType: any = 'ACH';

  prevParticipantId: any;
  prevOutboundConvId: any;
  prevOutboundBody: any;
  chatInteractionStatus: string = '';
  enableInbound: boolean = false;
  @Input() defaultRole: any = 'NA';
  @ViewChild(MatSelect) select!: MatSelect;
  mouseClicked: boolean = false;
  keyBoardRoleChange: boolean = false;
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (this.select?.panelOpen) {
      this.select.close();
    }
  }
  errorMsg = Constants.CUSTOMER_TYPE_FAILURE_MSG;
  validationSuccessMessage = Constants.indicativeMessages.validationSuccessMessage;
  pinEntrySuccessMessage = Constants.pinEntryMessages.validationSuccessMessage;
  otcValidateSuccessMessage = Constants.OTC_MESSAGES.OTC_VALIDATION_SUCCESS_MESSAGE;
  clearVerificationSuccessMessage = Constants.CLEAR_VERIFICATION_CONSTANTS.SUCCESS_MSG;
  OutBoundTimeoutId: ReturnType<typeof setTimeout> | any;
  constructor(
    public rootScope: RootScopeService,
    public customerService: CustBusService,
    public genesysCloudService: GenesysCloudService,
    public encryptDecryptService: EncryptDecryptService,
    public cusAccService: CustomerAccountBusinessLogicService,
    public apiService: ApiService,
    public initHistService: InteractionHistoryService

  ) {
    {
      this.iconConfig = {
        iconName: 'arrow-right',
        iconType: 'light',
        iconPlacement: 'right',
      };
    }
  }




  // Display the dropdown for role type
  // this is the static value. Please remove once feature works done for the same.
  roletypes = [
    { value: '11001', viewValue: 'Employee' },
    { value: '11002', viewValue: ' Contingent Worker ' },
    { value: '11003', viewValue: 'Manager' },
    { value: '11004', viewValue: 'HR Professional' },
    { value: '11005', viewValue: 'Union Representative' },
    { value: '11006', viewValue: 'QDRO' },
    { value: '11006', viewValue: 'Beneficiary' },
    { value: '11006', viewValue: 'Party of Interest' },
  ];

  @HostListener('window:resize', []) resize() {
    this.rootScope.activeCustTab.showContent = true;
  }

  ngOnInit(): void {
    this.defaultRole = this.rootScope.activeCustTab.defaultRole;
    if (this.rootScope.activeCustTab.tabData?.tabData?.platformInternalId)
      this.rootScope.activeCustTab.tabData.tabData.platformInternalId = this.cusAccService.activeTabDt?.roleTypeList.find(x => x.roleName == this.defaultRole)?.platformInternalId;

      

    this.initHistService.setWrapUpDefaultValue();
  }


  onRoleChangeFocusOut(event) {
    console.log("Method onRoleChangeFocusOut called", event)
    if (this.keyBoardRoleChange && !this.mouseClicked) {
      this.implementRoleChange();
    }
  }

  onKeyBoardRoleChange($event) {
    console.log("Method keyBoardRoleChange called ", $event)
    this.mouseClicked = false;
    this.keyBoardRoleChange = true;
  }

  clicked(event) {
    console.log("Method clicked called", event)
    this.mouseClicked = true;
    this.keyBoardRoleChange = false;
  }

  implementRoleChange() {
    console.log("implementRoleChange called", this.defaultRole)
    if (this.defaultRole != 'NA' && (this.defaultRole != this.rootScope.activeCustTab.defaultRole)) {
      this.rootScope.activeCustTab.defaultRole = this.defaultRole;
      if(!Constants.EXCLUDE_ROLE_TYPE.includes(this.defaultRole)) {
        this.rootScope.refreshAlertList = true;
      }
      this.rootScope.activeCustTab.roleObj = this.cusAccService.activeTabDt?.roleTypeList?.find(x => x.roleName == this.defaultRole);
      if (this.rootScope.TBAGUIConnected) {
        this.customerService.closeCustomerTbaScreens(this.rootScope.activeCustTab);
      }
      /* istanbul ignore next */
      setTimeout(() => {
        if (this.rootScope.activeCustTab.tabData?.tabData?.platformInternalId)
          this.rootScope.activeCustTab.tabData.tabData.platformInternalId = this.cusAccService.activeTabDt.roleTypeList.find(x => x.roleName == this.defaultRole)?.platformInternalId
      }, 600);

      let payload = {
        'customerSessionId': this.rootScope.activeCustTab.customerSessionId,
        'cusTab': {
          'defaultRole': this.rootScope.activeCustTab.defaultRole
        }
      }
      this.customerService.updateCustomerInElasticCache(payload);

      /**
       * Now call the api to get CA data for changes role
       */
      /*istanbul ignore next */
      let tabIndex = this.cusAccService?.customerAccountDt?.findIndex(
        (x) => x?.id == this.rootScope?.activeCustTab?.customerSessionId
      );
      let model = { url: Global.openAccountApi.customerNavigation, componentName: 'CUSTOMER-NAVIGATION', type: 'navBar' }
      this.cusAccService.getLatestCustomerAccDT(model, tabIndex);

      /** Updating Genesys about Role Change -(CCR1-3371) **/
      this.sendNotificationToGenesysForRoleChange();
    }
  }

  /**
   * Below method is used to update Genesys 
   * about role Type change and respectively
   * in conference /transfeered call .CSR2 will receive the updated role Type
   * @author :Pooja 
   * Below method is applicable for call and chats both
   * CCR1-3771
   */

  sendNotificationToGenesysForRoleChange() {
    if (this.cusAccService.customerTypeValidation()) {
      let conversationId = '';
      let participantId = '';

      if (this.rootScope.activeCustTab.activeChat) {
        conversationId = this.rootScope.activeCustTab.conversationId;
        participantId = this.rootScope.activeCustTab.customerParticipantId;
      }
      else {
        
        let genesysObj = this.rootScope.genesysCallObj;
        conversationId = genesysObj?.eventBody?.id;

        let liveCustomer = genesysObj?.eventBody?.participants?.find(
          (x) =>
            x?.['purpose'] == 'customer' &&
            x?.['state'] == 'connected'
        );
        participantId = liveCustomer?.id;
      }

      let body: CallCustomerAttributes = {
        attributes: {
          ROLE_TYPE: this.rootScope.activeCustTab?.defaultRole,
        },
      };
      this.updateCustomerTypeParticipantAttributes(
        conversationId,
        participantId,
        body
      );
    }
  }




  onRoleChange(event) {
    setTimeout(() => {
      if (this.mouseClicked)
        this.implementRoleChange();
    }, 100)

  }


  /** Below method call Genesys Cloud Service updateParticipantAttributes method and update the body in ALIS Participant
   *  Attributes if the user on live chat or call.*/
  updateCustomerTypeParticipantAttributes(conversationId, participantId, body) {
    this.genesysCloudService
      .updateParticipantAttributes(conversationId, participantId, body)
      .subscribe({
        next: (res) => {
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);
        },
        error: (err) => {
         if (!this.rootScope.simulationData.isSimulationToggleOn) {
          this.rootScope.isGENSYSErrorToHide = false;
          this.rootScope.errorMsg = Constants.GENSYS_CONS[401] + Constants.AlertMsg.genesysError;
          this.rootScope.indicatorClass = 'red';
          console.log(JSON.stringify(err));
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.FAILURE, err);
         }
        },
      });
  }

  /**Below method triggerOutboundCall() called to open the popup when outbound call is initiated and
   * along with the triggerOutboundCallCloseTimer() also called */
  triggerOutboundCall() {
    if (this.rootScope.isCallBackCall) {
      
      this.rootScope.isCallBackCall = false;
    }
    let callInitiaterAccount = this.rootScope.customerTabs.find(
      (x) => x.outboundCallInitiate == true
    );
    if (callInitiaterAccount) {
      
      this.rootScope.enableAlerts(
        Constants.WARNING,
        `You already have initiated an outbound call for ${callInitiaterAccount.tabData?.tabData.lastName}, ${callInitiaterAccount.tabData?.tabData.firstName}. Cancel that first before making another outbound call.`
      );
      
      this.rootScope.customerLink = callInitiaterAccount.customerSessionId;
      
      this.customerService.updateActiveTabDetails(this.rootScope.customerLink);

      
      this.rootScope.router.navigate(
        [`/customer-account/${this.rootScope.customerLink}`],
        {
          skipLocationChange: true,
        }
      );
    } else {
      // console.log('Method triggerOutboundCall called');
      this.customerService.updateOutboundCallInitiate(
        this.rootScope.activeCustTab.customerSessionId,
        true
      );
      if(this.rootScope.simulationData?.isSimulationModeActive){
       this.simulationOutbound();
      }
      else{
      this.handleOutboundCall();
      }
      this.triggerOutboundCallCloseTimer();
      this.rootScope.isErrorToHide = true;
    }
  }

  handleOutboundCall() {
    this.outboundCallTriggerSub =
      this.rootScope.genesysNotificationCall.subscribe({
        next: (genesysObj: any) => {
          let conversationId = genesysObj?.eventBody?.id;
          /* istanbul ignore next */
          let liveOutboundUser = genesysObj?.eventBody?.participants.find(
            (x) =>
              // x?.recording == true &&
              // x?.recordingState == 'active' &&
              x?.['purpose'] == 'customer' &&
              (x?.['state'] == Constants.ALIS_Live_Status.connected || x?.['state'] == Constants.ALIS_Live_Status.dialing) &&
              x?.['direction'] == 'outbound'
          );
          let participantId = liveOutboundUser?.id;
          let callInitiaterAccount = this.rootScope.customerTabs.find(
            (x) => x.outboundCallInitiate == true
          );
         /* istanbul ignore next */
          if (
            liveOutboundUser && !this.rootScope.isLiveCall &&
            !this.rootScope.checkBlankObj(liveOutboundUser?.attributes)
          ) {
            let externalId = callInitiaterAccount?.tabData?.tabData?.platformExternalId;
            let body: CallCustomerAttributes = {
              attributes: { 
                IS_CS_CUSTOMER_ID_ENCRYPTED: true,
                ENC_CS_CUSTOMER_ID: this.encryptDecryptService.encodeAndEncrypt(
                  externalId?.length > 12 ? this.encryptDecryptService.decrypt(externalId) : externalId
                ),
                CS_CLIENT_ID: callInitiaterAccount?.tabData?.tabData?.clientId,
                PINV: Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED,
                UDP_GBL_ID:
                  callInitiaterAccount?.tabData?.tabData
                    ?.globalPersonIdentifier,
                CUSTOMER_TYPE: callInitiaterAccount?.customerType,
                CS_CALLER_TYPE: callInitiaterAccount?.customerType, //added to transfer call from CSPro to Care Portal
                ROLE_TYPE: callInitiaterAccount?.defaultRole,
                QUEUE_NAME: this.genesysCloudService.getQueueNameFromGenEvent(liveOutboundUser),
               
              },
            };
            if(this.rootScope.identifyUserSubjectType(callInitiaterAccount?.tabData?.tabData?.clientId) && this.rootScope.callType == Constants.OUTBOUND_CALL_TYPE){
              delete body.attributes.UDP_GBL_ID
            }
            /* istanbul ignore next */
            this.prevOutboundConvId = conversationId;
            /* istanbul ignore next */
            this.prevParticipantId = participantId;
            /* istanbul ignore next */
            this.prevOutboundBody = body;
            /* istanbul ignore next */
            this.updateParticipantAttributes(
              conversationId,
              participantId,
              body,
              callInitiaterAccount?.id
            );
          }
        
        },
        error: (error) => { },
      });
  }

  /**Below method   cancelTriggerOutboundCall() called when outbound call popup close on cancel button */
  cancelTriggerOutboundCall() {
    // console.log('Method cancelTriggerOutboundCall called');
    clearTimeout(this.myTimeoutId);
    if(this.rootScope.simulationData?.isSimulationModeActive){
      clearTimeout(this.OutBoundTimeoutId);
    }
    this.customerService.updateOutboundCallInitiate(
      this.rootScope.activeCustTab.customerSessionId,
      false
    );
    this.outboundCallTriggerSub.unsubscribe();
    this.rootScope.isWarningToHide = true;
  }

  /**Below method triggerOutboundCallCloseTimer() is for timer to close the outbound call popup
   * after 10 sec or one minute.*/

  triggerOutboundCallCloseTimer() {
    // console.log('Method triggerOutboundCallCloseTimer called');
    /*istanbul ignore next */
    this.myTimeoutId = setTimeout(() => {
      if(this.rootScope.activeCustTab.outboundCallInitiate){
      this.customerService.updateOutboundCallInitiate(
        this.rootScope.activeCustTab.customerSessionId,
        false
      );
      this.outboundCallTriggerSub.unsubscribe();
      this.rootScope.enableAlerts(
        Constants.ERROR,
        Constants.errorOutBoudCall_MSG
      );   
      /* istanbul ignore next */ 
      setTimeout(() => {
        this.rootScope.isErrorToHide = !this.rootScope.isErrorToHide;
      }, 60000);
    }
    else this.cancelTriggerOutboundCall();
    },  this.rootScope.CCTConfigs.OUTBOUND_POPUP_TIME * 1000);
  }

  updateParticipantAttributes(conversationId, participantId, body, id?) {
    /* istanbul ignore next */
    if (id) {
      let outboundTab = this.rootScope.customerTabs.find(
        (x) => x.outboundCallInitiate == true
      ); //to handle multiple tab opened user start outbound call in one tab but user working other customer
      this.rootScope.customerLink = outboundTab?.customerSessionId;
      this.customerService.updateActiveTabDetails(this.rootScope.customerLink);
      this.rootScope.router.navigate(
        [`/customer-account/${this.rootScope.customerLink}`],
        {
          skipLocationChange: true,
        }
      );
      if (this.rootScope.activeCustTab.id == id)
        this.rootScope.activeCustTab.conversationId = conversationId;
    }

    /*istanbul ignore next */
    this.genesysCloudService
      .updateParticipantAttributes(conversationId, participantId, body)
      .subscribe({
        next: (res) => {
          this.cancelTriggerOutboundCall();
          this.customerService.handleOutboundCallDialingOrConnected();
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);

          // console.log(
          //   'patchConversationsCallbackParticipantAttributes returned successfully.'
          // );
          //CCR6-1212 Below function is called to show Recording popup.
          if (!this.rootScope.outBoundPopUp) {
            this.customerService.openRecordingDialPopUp();
          }
          // this.cusAccService.openRecordDialog();
        },
        error: (err) => {
          this.rootScope.activeCustTab.conversationId = 'NA';
          this.cancelTriggerOutboundCall();
          this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.AlertMsg.error500
          );
          // console.log(
          //   'There was a failure calling patchConversationsCallbackParticipantAttributes'
          // );
        },
      });
  }

  goToAuthenticatePage() {
    let obj: any = {};
    this.goToAuthenticatePageEmitter.emit(obj);
  }

  /** Interaction function to get interaction status value for all interactions
   * Created as part of CCR3-1858
   *
   * returns Interaction status for current tab
   *
   */
  getInteractionStatus() {
    let interactionStatus = '';
    let inactiveAppender = '';

    if (
      !this.rootScope.activeCustTab.activeCall &&
      !this.rootScope.activeCustTab.activeChat &&
      this.isConversationIdPresent()
    ) {
      if (this.rootScope.activeCustTab.lastInteractionStatus == 'Outbound Call (Dialing)') {
        this.rootScope.activeCustTab.lastInteractionStatus = 'Outbound Call';
      }
      inactiveAppender = ' (inactive)';
      return (
        this.rootScope.activeCustTab.lastInteractionStatus + inactiveAppender
      );
    }
    const intractStatusKey = '';

    if (
      !this.rootScope.activeCustTab.activeCall &&
      !this.rootScope.activeCustTab.activeChat &&
      !this.isConversationIdPresent()
    ) {
      interactionStatus = intractStatusKey + 'Research';
    }
    if (this.rootScope.activeCustTab.activeCall) {
      if (
        this.checkInboundCall() &&
        !this.rootScope.istransferred &&
        !this.rootScope.isConference
      ) {
        interactionStatus = intractStatusKey + 'Inbound Call';
      } else if (!this.checkInboundCall() && !this.rootScope.isCallBackCall) {
        
        interactionStatus = intractStatusKey + 'Outbound Call';
        /* istanbul ignore next */
        if (this.rootScope.activeCustTab.outboundCallDialing) {
          interactionStatus = intractStatusKey + 'Outbound Call (Dialing)'
        }
      } else if (!this.checkInboundCall() && this.rootScope.isCallBackCall) {
        interactionStatus = intractStatusKey + 'Callback from Queue';
      } else if (this.checkInboundCall() && this.rootScope.istransferred) {
        interactionStatus = intractStatusKey + 'Transferred Call';
      } else if (this.checkInboundCall() && this.rootScope.isConference) {
        interactionStatus = intractStatusKey + 'Conference Call';
      }
    } else if (this.getActiveChatInteractionStatus()) {
      interactionStatus = intractStatusKey + this.chatInteractionStatus;
    }
    this.rootScope.activeCustTab.lastInteractionStatus = interactionStatus;

    return interactionStatus;
  }

  checkInboundCall() {
    if (
      this.rootScope.activeCustTab.activeCall &&
      this.rootScope.callType == Constants.INBOUND_CALL_TYPE
    ) {
      this.enableInbound = true;
    } else {
      this.enableInbound = false;
      this.rootScope.isOutBoundCall = true;
    }
    return this.enableInbound;
  }

  isConversationIdPresent() {
    if (
      this.rootScope.activeCustTab.conversationId &&
      this.rootScope.activeCustTab.conversationId != 'NA'
    )
      return true;
    else return false;
  }

  /**Below method return the boolean value if there is any active chat in the active customer tab and
   * update the chatInteractionStatus to Chat or Transferred Chat  by checking the boolean value of
   * isChatTransferred variable of active customer tab and this method is called in customer account html template to
   * show Chat Interaction*/
  getActiveChatInteractionStatus() {
    if (this.rootScope.activeCustTab.activeChat) {
      if (this.rootScope.activeCustTab.isChatTransferred) {
        this.chatInteractionStatus =
          Constants.INTERACTION_STATUS.TRANSFERRED_CHAT;
      } else {
        this.chatInteractionStatus = Constants.INTERACTION_STATUS.CHAT;
      }
      return true;
    } else {
      return false;
    }
  }

  liveIcon(tab, type) {
    return this.rootScope.liveIcon(tab, type);
  }


  changeCustomerType(event: any) {
    this.changeCustomerTypeEmitter.emit(event);
  }

  /**
 * getMethodName() - returning Authenticated method name.
 * @author Amarjeet
 */
  getMethodName(){
    let methodId=this.rootScope.activeCustTab?.genesysAttributes?.CS_AUTH_CD;
    return methodId && Constants.AuthMethods[methodId] ? '['+ Constants.AuthMethods[methodId ]+']':'';
  }
  //
  /**
   * Simulates an outbound call interaction by preparing participant data, 
   * updating conversation attributes, and triggering related services.
   * 
   * - Finds the account initiating the outbound call.
   * - Encrypts and sets customer identifiers and other attributes for the outbound participant.
   * - Sets call direction, address, and timestamps.
   * - Generates a unique conversation ID and updates the active customer tab.
   * - Calls Genesys Cloud service to identify the call as inbound or outbound.
   * - Cancels any outbound call triggers and opens the recording dial popup after a short delay.
   * 
   * The entire simulation is delayed by a configurable amount (default: 5 seconds) before execution,
   * as set by this.rootScope.simulation_outbound_time.
   * CCR3-4940
   */
  simulationOutbound() {

    
    this.OutBoundTimeoutId = setTimeout(() => {
      const OUTBOUND_CONVERSATION = ALIS_OUTBOUND_CONVERSATION;

      let callInitiaterAccount = this.rootScope.customerTabs.find(
        (x) => x.outboundCallInitiate == true
      );
      let externalId = callInitiaterAccount?.tabData?.tabData?.platformExternalId;
      const lobType = this.rootScope.Simulation_LOB_map.get(callInitiaterAccount?.tabData?.tabData?.clientId)?.sort((a, b) => a?.['authModels'].localeCompare(b?.['authModels']));
      
      let data = {
        IS_CS_CUSTOMER_ID_ENCRYPTED: true,
        ENC_CS_CUSTOMER_ID: this.encryptDecryptService.encodeAndEncrypt(
          externalId?.length > 12 ? this.encryptDecryptService.decrypt(externalId) : externalId
        ),
        CS_CLIENT_ID: callInitiaterAccount?.tabData?.tabData?.clientId,
        PINV: Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED,
        UDP_GBL_ID:
          callInitiaterAccount?.tabData?.tabData
            ?.globalPersonIdentifier,
        CUSTOMER_TYPE: callInitiaterAccount?.customerType,
        CS_CALLER_TYPE: callInitiaterAccount?.customerType, //added to transfer call from CSPro to Care Portal
        ROLE_TYPE: callInitiaterAccount?.defaultRole,
        QUEUE_NAME: `${callInitiaterAccount?.clientId}_${this.customerService.getClientName(callInitiaterAccount?.clientId)}_${Constants.SIM_QUEUE_NAME}`

      }

      const rowData = callInitiaterAccount?.tabData?.tabData;
      Object.keys(data).forEach(key => {
        OUTBOUND_CONVERSATION.participants[1].attributes[key] = data[key];
      }
      );
      OUTBOUND_CONVERSATION.participants[1].address = Constants.SIM_PARTICIPANT_ANI;
      OUTBOUND_CONVERSATION.participants[1].direction = Constants.SIM_OUTBOUND_DIRECTION;

      OUTBOUND_CONVERSATION.participants[1].startTime = new Date().toISOString();
      OUTBOUND_CONVERSATION.participants[1].connectedTime = new Date().toISOString();
      OUTBOUND_CONVERSATION.participants[1].attributes[Constants.ALS_LP_ATB] = lobType?.[0]?.['lobTypes']?.[0]||Constants.DUEL_DESKTOP_INDICATOR_CARE_PORTAL;
      let liveOutboundUser = OUTBOUND_CONVERSATION.participants[1];
      liveOutboundUser.startTime = new Date().toISOString();
      const uuid = crypto.randomUUID();
      const conversationID = uuid.replace(/-/g, '');
  
      this.rootScope.activeCustTab.conversationId = conversationID;
      let response = { conversationId: conversationID, clientValue: liveOutboundUser, liveUser: liveOutboundUser };
      this.genesysCloudService.identifyInboundOrOutBoundCall(response.liveUser, response.clientValue, response.conversationId);
      const startTime = new Date();
      this.rootScope.simulationRecords.push({ fullName: `${rowData?.lastName}, ${rowData?.firstName}`, channel: Constants.conversion.call, conversationAttributes: OUTBOUND_CONVERSATION.participants[1].attributes, conversationId: conversationID, startTime: startTime });
      // CCR3-13239 Regression Bug Fix - User focus stays on simulation mode page when call is started
      this.rootScope.router.navigate(
        [`/customer-account/${this.rootScope.customerLink}`],
        {
          skipLocationChange: true,
        }
      );
      this.cancelTriggerOutboundCall();
      setTimeout(() => {

        this.cusAccService.openRecordDialog();

      }, 100);

    }, this.rootScope.simulation_outbound_time);
  }
}
